import React from 'react';
import { Loader } from 'Components/Loader';
import './Overlay.css';
import { useStore } from 'Hooks/useStore';

export default function Overlay() {
  const { showOverlay, overlayMessage, showOverlayLoader } = useStore('pageLayout');

  if (!showOverlay) return null;

  return (
    <div className="overlay show">
      {overlayMessage && <h3 className="overlayMessage">{overlayMessage}</h3>}
      {showOverlayLoader && (
        <div className="overlayLoader">
          <Loader />
        </div>
      )}
    </div>
  );
}
